let restoreChange = require('../../actions/auth/restore-change');
let utils = require('../../actions/utils');

module.exports = {
    passwordChange: [
        utils.set(['restoreChange', 'ui', 'restoreButton', 'isDisabled'], true),
        [
            restoreChange.passwordChange, {
                success: [
                    utils.set(['page', 'name'], 'alert'),
                    utils.set(['auth', 'alert', 'type'], 'changePasswordSuccess')
                ],
                invalidToken: [
                    utils.set(['restoreChange', 'error', 'errorType'], 'invalidToken')
                ],
                notFound: [
                    utils.set(['restoreChange', 'error', 'errorType'], 'notFound')
                ],
                error: [
                    utils.set(['restoreChange', 'error', 'errorType'], 'internalError')
                ]
            }
        ],
        utils.set(['restoreChange', 'ui', 'restoreButton', 'isDisabled'], false)
    ]
};



// WEBPACK FOOTER //
// ./signals/auth/restore-change.js